import axios from "axios";
import router from "../router";
import Vue from "vue";

const Authentification = {
    namespaced: true,
    state: {
        status: null,
        drawer: false,
        user: {}
    },
    actions: {
        setDrawer(context, value) {
            context.commit("SETDRAWER", value)
        },
        // getUserConnected(context) {
        //     return new Promise((resolve, reject) => {
        //         Vue.axios.get(window.urlapi_login + "user").then(
        //             response => {
        //                 if (typeof response.data.data.id_membre !== "undefined") {
        //                     context.commit("GETUSERCONNECTED", response.data.data);
        //                     resolve();
        //                 } else {
        //                     Vue.prototype.$awn.alert(
        //                         "Echec de la récupération de l'utilisateur : " +
        //                         response.data.message.toString(),
        //                         {
        //                             position: "bottom-right",
        //                             timeout: 3000
        //                         }
        //                     );
        //                 }
        //             }
        //         );
        //     })
        // },
        login(context, usercredential) {
            let formData = new FormData();
            formData.append("utilisateur", usercredential.username);
            formData.append("motDePasse", usercredential.password);
            formData.append('mode', 'login');

            Vue.axios.post(window.urlapi + "login.php", formData).then(
                response => {
                    if (typeof response.data.data !== "undefined") {
                        Vue.prototype.$awn.success("Connexion réussie !", {
                            position: "bottom-right",
                            timeout: 3000
                        });
                        context.commit("LOGIN", response.data);
                        context.commit('GETUSERCONNECTED', response.data.data[0]);
                        localStorage.setItem('user_connected', JSON.stringify(response.data.data[0]));

                        if (response.data.success)
                            router.push({ name: "envs" });
                        // context.dispatch("getUserConnected");

                    }
                },
            );
        },
        logout(context, user) {
            context.commit("LOGOUT", user);
        },
        setUserConnected(context, user) {
            context.commit("GETUSERCONNECTED", user);
        }
    },
    mutations: {
        LOGIN: (state, data) => {
            state.status = "success";
            state.user = data;
            router.push({ name: "themes" });
        },
        LOGOUT: state => {
            try {
                state.status = "failure";
                state.user = {};
                router.push({ name: "Login" });
            } catch (err) {
                Vue.prototype.$awn.alert(
                    "Erreur de deconnexion"
                );
            }
        },
        SETDRAWER: (state, variable) => {
            state.drawer = variable;
        },
        GETUSERCONNECTED: (state, user) => {
            state.user = user;
        }
    },
    getters: {
        isAuthenticated: state => !!state.token,
        authStatus: state => state.status,
        drawerStatus: state => state.drawer,
        userConnected: state => {
            if (typeof state.user === 'undefined' || state.user.userId == null)
                return JSON.parse(localStorage['user_connected']);

            return state.user;
        },
        isUserConnected: state => !!state.user.length,
        isActivated: state => state.user.user_confirm || false
    }
};
export default Authentification;
